export default class JobStatusExternalCategory {
	/**
	 * Job status external category model
	 * @param {string} id
	 * @param {JobStatusExternalCategoryEnum} value
	 * @param {string} label
	 */
	constructor(public readonly id: string,
		public readonly value: JobStatusExternalCategoryEnum,
		public readonly label: string) {}

	/**
	 * Get all external job status categories.
	 * @returns {JobStatusCategory[]}
	 */
	static getJobStatusExternalCategories(): JobStatusExternalCategory[] {
		return [
			JobStatusExternalCategory.createExternalCategory(JobStatusExternalCategoryEnum.ORDERING),
			JobStatusExternalCategory.createExternalCategory(JobStatusExternalCategoryEnum.INVOICING),
			JobStatusExternalCategory.createExternalCategory(JobStatusExternalCategoryEnum.CLOSED),
			JobStatusExternalCategory.createExternalCategory(JobStatusExternalCategoryEnum.CANCELLED)
		];
	}

	static createExternalCategory(category: JobStatusExternalCategoryEnum): JobStatusExternalCategory {
		return new JobStatusExternalCategory(category, category, category.capitalize());
	}
}

export enum JobStatusExternalCategoryEnum {
	ORDERING = "ORDERING",
	INVOICING = "INVOICING",
	CLOSED = "CLOSED",
	CANCELLED = "CANCELLED"
}